/**
 * Comprueba si un string es una URL válida para imágenes (http/https).
 * Si media guarda solo nombres de archivo (ej. "foto.png"), no son URLs válidas.
 */
export function isValidImageUrl(url: string | undefined | null): boolean {
  if (!url || typeof url !== 'string') return false;
  return /^https?:\/\//i.test(url.trim());
}
